export const textSplitter = (a: string | number | undefined, b: string | number, splitter: string) =>
    `${a}${splitter}${b}`;
